import { render } from "./ReserveAVehicle.vue?vue&type=template&id=1462d531&lang=true"
import script from "./ReserveAVehicle.vue?vue&type=script&lang=js"
export * from "./ReserveAVehicle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ChatWidget/AssistantAi/StartUpIcons/ReserveAVehicle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1462d531"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1462d531', __exports__)) {
    api.reload('1462d531', __exports__)
  }
  
  module.hot.accept("./ReserveAVehicle.vue?vue&type=template&id=1462d531&lang=true", () => {
    api.rerender('1462d531', render)
  })

}


export default __exports__